import { AgTechFileUploadButton } from "@agtech/web/components/Buttons/AgTechButtons";
import { AgTechStandardModal } from "@agtech/web/components/Portals/Modals/AgTechModal";
import AgTechTabbedPage from "@agtech/web/components/Pages/Tabbed/AgTechTabPage";
import { AgTechImportModalResultViewProps } from "../common/AgTechImportTypes";
import { useFailedImportResultsTabs } from "../common/AgTechImportHelpers";

const AgTechFailedImportResultsView = <TImportItem, TContext = {}>(props: AgTechImportModalResultViewProps<TImportItem, TContext>) => {
    let failedImportResultsTabs = useFailedImportResultsTabs(props);
    
    return (
        <AgTechStandardModal
            title={`${props.content.importEntitySingular} Import Results & Errors`}
            details='Below are the import errors found while importing the selected file. To see why each error occurred, hover over the warning symbol on the error.'
            body={() => <AgTechTabbedPage {...failedImportResultsTabs} />}
            footer={() => (
                <div className='column-based wide container'>
                    <h1 className='font-size-medium font-bold'>
                        When all import errors have been addressed, please import your file again
                    </h1>
                    <div className='vertically-centered ml-auto container'>
                        <AgTechFileUploadButton
                            text='Upload New File'
                            icon='fas fa-upload'
                            onFileUploaded={props.onImportAgain}
                            classes='button-highlight py-2 px-5'
                        />
                    </div>
                </div>
            )}
        />
    )
}

export default AgTechFailedImportResultsView;